import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RatesStore } from '@xilo-mono/shared/quotes';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-hard-rate',
  templateUrl: './hard-rate.component.html',
  styleUrls: ['./hard-rate.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HardRateComponent {
  protected readonly callBox$ = new BehaviorSubject(false);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly ratesStore = inject(RatesStore);
  protected readonly quote = this.ratesStore.getSelectedQuote();

  onCall() {
    this.callBox$.next(!this.callBox$.value);
  }

  editQuote() {
    this.router.navigate(['rates'], {
      relativeTo: this.route.parent,
      queryParams: this.route.snapshot.queryParams,
    });
  }
}
